<div class="container-fluid">
  <div class="row">
    <div class="col-md-12 mb-2">
      <div class="breadcrumb-title mb-3 mt-md-0 mt-4">
        <app-list-header
          [title]="'APP_PURCHASED.TITLE' | translate"
          icon="bi bi-bag-check"
          [$parent]="getSelf()"
        >
        </app-list-header>
      </div>
    </div>

    <div class="col-md-12">
      <div class="card">
        <div class="search-card compact-inputs">
          <div class="card-header search-card-header border-bottom-0">
            <button
              mat-stroked-button
              color="primary"
              class="ms-1"
              (click)="toggleSearch()"
              matTooltip="{{ 'APP_PURCHASED.SEARCH.FILTER' | translate }}"
            >
              <mat-icon>tune</mat-icon>
              <span>{{ "APP_PURCHASED.SEARCH.FILTER" | translate }}</span>
            </button>
            <button
              mat-stroked-button
              color="warn"
              class="ms-2"
              (click)="restoreColumnOrder()"
              [disabled]="!isColumnOrderChanged()"
              matTooltip="Restore Table Column Order"
              aria-label="Restore Table Column Order"
            >
              <mat-icon>restore</mat-icon>
              <span class="ms-1">{{
                "APP_PURCHASED.SEARCH.RESTORE" | translate
              }}</span>
            </button>
          </div>

          <div *ngIf="isExpanded" class="pb-0 card-body">
            <div
              class="row align-items-center mt-1 compact-inputs dropdown-pd-none"
            >
              <!-- Application Name -->
              <div class="col-xxl-3 col-xl-4 col-md-6 col-sm-6 col-12 mb-2">
                <div class="d-flex justify-content-start align-items-center">
                  <div class="ms-1 flex-grow-1">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>{{
                        "APP_PURCHASED.SEARCH.APPlication_NAME" | translate
                      }}</mat-label>
                      <input matInput [(ngModel)]="applicationName" />
                    </mat-form-field>
                  </div>
                  <button
                    mat-icon-button
                    matTooltip="{{
                      'APP_PURCHASED.SEARCH.Tooltip.APP_Name' | translate
                    }}"
                    matTooltipPosition="above"
                    class="icon-center icon-clean"
                    aria-label="Application Name"
                  >
                    <mat-icon class="text-secondary icon-compact"
                      >info</mat-icon
                    >
                  </button>
                </div>
              </div>

              <div class="col-xxl-3 col-xl-4 col-md-6 col-sm-6 col-12 mb-2">
                <div class="d-flex justify-content-start align-items-center">
                  <div class="ms-1 flex-grow-1">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>{{
                        "APP_PURCHASED.SEARCH.OWNER" | translate
                      }}</mat-label>
                      <input matInput placeholder="" [(ngModel)]="ownerName" />
                    </mat-form-field>
                  </div>
                  <button
                    mat-icon-button
                    matTooltip="{{
                      'APP_PURCHASED.SEARCH.Tooltip.Owner' | translate
                    }}"
                    matTooltipPosition="above"
                    class="icon-center icon-clean"
                    aria-label="Owner"
                  >
                    <mat-icon class="text-secondary icon-compact"
                      >info</mat-icon
                    >
                  </button>
                </div>
              </div>

              <div class="col-xxl-3 col-xl-4 col-md-6 col-sm-6 col-12 mb-2">
                <div class="d-flex justify-content-start align-items-center">
                  <div class="ms-1 flex-grow-1">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>{{
                        "APP_PURCHASED.SEARCH.ACCESS_KEY" | translate
                      }}</mat-label>
                      <input matInput placeholder="" [(ngModel)]="accessKey" />
                    </mat-form-field>
                  </div>
                  <button
                    mat-icon-button
                    matTooltip="{{
                      'APP_PURCHASED.SEARCH.Tooltip.Access_Key' | translate
                    }}"
                    matTooltipPosition="above"
                    class="icon-center icon-clean"
                    aria-label="Access Key"
                  >
                    <mat-icon class="text-secondary icon-compact"
                      >info</mat-icon
                    >
                  </button>
                </div>
              </div>

              <div class="col-xxl-3 col-xl-4 col-md-6 col-sm-6 col-12 mb-2">
                <div class="d-flex justify-content-start align-items-center">
                  <div class="ms-1 flex-grow-1">
                    <mat-form-field appearance="outline" class="w-100">
                      <!-- <mat-label>Status</mat-label> -->
                      <mat-select [(ngModel)]="status">
                        <mat-option value="">{{
                          "APP_PURCHASED.SEARCH.STATUS.NO_STATUS" | translate
                        }}</mat-option>
                        <mat-option value="hold">{{
                          "APP_PURCHASED.SEARCH.STATUS.HOLD" | translate
                        }}</mat-option>
                        <mat-option value="pending">{{
                          "APP_PURCHASED.SEARCH.STATUS.PENDING" | translate
                        }}</mat-option>
                        <mat-option value="approved">{{
                          "APP_PURCHASED.SEARCH.STATUS.APPROVED" | translate
                        }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>

                  <button
                    mat-icon-button
                    matTooltip="{{
                      'APP_PURCHASED.SEARCH.Tooltip.Status' | translate
                    }}"
                    matTooltipPosition="above"
                    class="icon-center icon-clean"
                    aria-label="Status"
                  >
                    <mat-icon class="text-secondary icon-compact"
                      >info</mat-icon
                    >
                  </button>
                </div>
              </div>

              <div class="col-xxl-3 col-xl-4 col-md-6 col-sm-6 col-12 mb-2">
                <div class="d-flex justify-content-start align-items-center">
                  <div class="ms-1 flex-grow-1">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>{{
                        "APP_PURCHASED.SEARCH.DATE" | translate
                      }}</mat-label>
                      <input
                        matInput
                        placeholder=""
                        [(ngModel)]="createdDatetime"
                      />
                    </mat-form-field>
                  </div>
                  <button
                    mat-icon-button
                    matTooltip="{{
                      'APP_PURCHASED.SEARCH.Tooltip.Search_Date' | translate
                    }}"
                    matTooltipPosition="above"
                    class="icon-center icon-clean"
                    aria-label="Date"
                  >
                    <mat-icon class="text-secondary icon-compact"
                      >info</mat-icon
                    >
                  </button>
                </div>
              </div>

              <!-- Action Buttons -->
              <div class="col-xxl-3 col-xl-4 col-md-6 col-sm-6 col-12 mb-2">
                <div class="d-flex">
                  <button
                    mat-stroked-button
                    color="primary"
                    class="ms-1 d-flex align-items-center"
                    (click)="searchBought()"
                  >
                    <mat-icon>search</mat-icon>
                    <span>{{ "APP_PURCHASED.SEARCH.Search" | translate }}</span>
                  </button>
                  <button
                    mat-stroked-button
                    color="warn"
                    class="ms-2"
                    (click)="resetFilters()"
                  >
                    <i class="fa fa-eraser eraser-warn-dark"></i>
                    <span class="ms-2">{{
                      "APP_PURCHASED.SEARCH.RESET" | translate
                    }}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="table-container">
            <div class="table-responsive table-scrollable">
              <table
                class="table table-bordered table-hover table-sticky-header"
              >
                <thead>
                  <tr
                    cdkDropList
                    cdkDropListOrientation="horizontal"
                    (cdkDropListDropped)="drop($event)"
                    [cdkDropListData]="displayedColumns"
                  >
                    <!-- Dynamic Columns -->
                    <th
                      *ngFor="let col of getCurrentColumns(); let i = index"
                      cdkDrag
                      [cdkDragData]="col"
                    >
                      <div class="header-content">
                        <span class="drag-handle" cdkDragHandle>⋮⋮</span>

                        <!-- LABEL + SORT -->
                        <span
                          class="header-label"
                          [class.not-sortable]="!col.sortable"
                          (click)="sortTable(col.key)"
                        >
                          {{ col.label | translate }}
                          <!-- SORT ICONS ONLY IF SORTABLE -->
                          <ng-container *ngIf="col.sortable">
                            <i
                              *ngIf="
                                sortedField === col.key && sortOrder === 'ASC'
                              "
                              class="fa fa-sort-up ms-1"
                            ></i>
                            <i
                              *ngIf="
                                sortedField === col.key && sortOrder === 'DESC'
                              "
                              class="fa fa-sort-down ms-1"
                            ></i>
                            <i
                              *ngIf="sortedField !== col.key"
                              class="fa fa-sort ms-1 text-muted"
                            ></i>
                          </ng-container>
                        </span>
                      </div>
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <!-- Table Rows -->
                  <tr *ngFor="let row of form.list; let i = index">
                    <td
                      *ngFor="let col of getCurrentColumns()"
                      [class.text-center]="col.key === 'sno'"
                    >
                      <ng-container [ngSwitch]="col.key">
                        <!-- S.NO -->
                        <span *ngSwitchCase="'sno'">
                          {{ pageIndex(i) }}
                        </span>

                        <!-- App -->
                        <span *ngSwitchCase="'applicationName'">
                          {{ row.applicationName }}
                        </span>

                        <!-- Owner -->
                        <span *ngSwitchCase="'ownerName'">
                          {{ row.ownerName }}
                        </span>

                        <!-- Access Key -->
                        <span *ngSwitchCase="'accessKey'">
                          <ng-container
                            *ngIf="row.status === 'approved'; else mask"
                          >
                            <span class="access-key-text">{{
                              row.accessKey
                            }}</span>
                          </ng-container>
                          <ng-template #mask>
                            <span class="text-muted">
                              {{ "appPurchased.table.maskedKey" | translate }}
                            </span>
                          </ng-template>
                        </span>

                        <!-- Status -->
                        <span *ngSwitchCase="'status'">
                          <span
                            class="status-badge"
                            [ngClass]="getStatusClass(row.status)"
                          >
                            {{ row.status }}
                          </span>
                        </span>

                        <!-- Date -->
                        <span *ngSwitchCase="'createdDatetime'">
                          {{ row.createdDatetime | date: "mediumDate" }}
                          <small class="text-muted d-block">
                            {{ row.userFirstname }} | {{ row.organizationName }}
                          </small>
                        </span>

                        <!-- Action -->
                        <span *ngSwitchCase="'action'">
                          <button
                            mat-stroked-button
                            color="warn"
                            (click)="goto(row.id)"
                          >
                            <mat-icon class="icon-compact">clear</mat-icon>
                            <span>{{
                              "APP_PURCHASED.SEARCH.Tooltip.Cancel_Subscription"
                                | translate
                            }}</span>
                          </button>
                        </span>
                      </ng-container>
                    </td>
                  </tr>

                  <!-- No Records -->
                  <!-- <tr *ngIf="dataSource.length === 0">
                                        <td [attr.colspan]="getCurrentColumns().length" class="text-center py-4">
                                            <div class="text-muted">
                                                <i class="fas fa-inbox fa-2x mb-2"></i>
                                                <p>No records found</p>
                                            </div>
                                        </td>
                                    </tr> -->
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>